import Swiper from 'swiper';
import { Navigation  } from 'swiper';

import $ from 'jquery'; // Ensure jQuery is imported
import '@fancyapps/fancybox'; // Import Fancybox


export function imagesCarousel() {
    $('.images-carousel__wrapper').each(function(){
        let block = $(this);
        let slider = $(this).find('.images-carousel__slider');
        const imagesSlider = new Swiper(slider.get(0), {
            // Common parameters
            loop: true,
            spaceBetween: 0,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            // Responsive breakpoints
            breakpoints: {
                // When window width is >= 1024px (desktop)
                1024: {
                    slidesPerView: 3,
                },
                // When window width is >= 768px and < 1024px (tablet)
                768: {
                    slidesPerView: 2,
                },
                // When window width is < 768px (mobile)
                0: {
                    slidesPerView: 1,
                },
            },
            modules: [Navigation],
        });
    });
    
    // Initialize Magnific Popup
    $('[data-fancybox="gallery"]').fancybox({
        showClass: false,
        hideClass: false,
        hash: false,
        buttons: ["close"], // Specify only the close button
        infobar: false, // Hide the infobar
        toolbar: true, // Keep the toolbar so the close button appears
        smallBtn: false, // Hide the small close button inside the content area
        arrows: false, // Hide navigation arrows
        animationEffect: "none",
        autoSize: true, // Ensures the content fits within the viewport.
        clickContent: false, // Disables zoom on click.
        margin: [44, 0, 44, 0],
        afterShow: function(instance, current) {
            // Assuming `current.$content` is the content area for the image
            // Check if our custom caption element exists, if not, create it
            let captionText = current.opts.$orig.data('caption');
            if (captionText) {
              // Check if a caption element already exists
              let captionElement = current.$content.find('.custom-caption');
              if (captionElement.length === 0) {
                // Create a new caption element if it doesn't exist
                captionElement = $('<div class="fancybox-custom-caption"></div>').appendTo(current.$content);
              }
              // Set the text for the caption element
              captionElement.html(captionText);
            }
        }
    });
}
